<template>
  <map-component :marker="marker" :center="mapCenter" :zoom="zoom" :tilesUrl="tilesUrl" />
</template>

<script>
import MapComponent from '@witkac/osm-map';

import { TILES_URL } from '@/utils/constants';

// @vuese
// Kontener mapy
// @group Map
export default {
  components: { MapComponent },
  props: {
    // Dane markera
    marker: {
      type: Object,
      required: false
    },
    // Środek mapy
    center: {
      type: Array,
      required: false
    },
    // Poziom przybliżenia mapy
    zoom: {
      type: Number,
      required: false,
      default: 12
    }
  },
  data() {
    return {
      tilesUrl: TILES_URL
    };
  },
  computed: {
    mapCenter() {
      if (this.center) {
        return this.center;
      }
      if (this.marker) {
        return [this.marker.lat, this.marker.lng];
      }
    }
  }
};
</script>